import { useEffect } from 'react';

export function usePageView(page) {
  useEffect(() => {
    fetch('/api/pageview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page }),
    }).catch(() => {});
  }, [page]);
}
